import classNames from 'classnames'
import { values } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import Tappable from 'react-tappable'

import css from './setup-goal.scss'
import { GOAL_STATES, GOAL_TYPES } from 'registry/constants'

class SetupGoal extends Component {
  static propTypes = {
    hideText: PropTypes.bool,
    icon: PropTypes.node,
    id: PropTypes.string,
    onClick: PropTypes.func,
    state: PropTypes.oneOf(values(GOAL_STATES)),
    text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    type: PropTypes.oneOf(values(GOAL_TYPES)),
  }

  static defaultProps = {
    hideText: false,
  }

  render() {
    const { icon, id, onClick, state, text, type } = this.props
    const className = classNames(css.goal, {
      [css.completed]: state == GOAL_STATES.COMPLETE,
      [css.reward]: type == GOAL_TYPES.REWARD,
    })
    return (
      <Tappable
        id={id}
        className={classNames(css.container, 'registry-tile btn-unstyled')}
        component="button"
        onClick={onClick}
      >
        <div className={className}>
          <div className={css.iconContainer}>
            <span className={css.tileIcon}>{icon}</span>
          </div>
          <div
            className={classNames(css.text, {
              [css.hidden]: this.props.hideText,
            })}
          >
            {text}
          </div>
          <i
            className={classNames(
              css.status,
              state == GOAL_STATES.COMPLETE ? 'fa-check' : 'fa-chevron-right',
              'fa h7'
            )}
          />
        </div>
      </Tappable>
    )
  }
}

export default SetupGoal
